import { MANAGED_STREAM_RESOURCES } from '../types';

/**
 * Filter the given array of strings to make sure they only contain resources managed by the stream
 * and sort them by the intended order
 */
export const filterAndSortManagedStreamResources = (values: Array<string> = []) =>
    MANAGED_STREAM_RESOURCES.filter((resource) => values.includes(resource));
